import Warehouse from './Warehouse';

export default Warehouse;
